import {
  SupportBar as ExportSupportBar,
  SupportBarProps as ExportSupportBarProps
} from './support-bar/SupportBar'

import { User as ExportUser } from './support-bar/user-panel/UserDetailsPanel'
import { Label } from './support-bar/notifications/notification-utils'
import ExportVantageTitle from "./support-bar/vantage-title/VantageTitle";

export const SupportBar = ExportSupportBar
export type SupportBarProps = ExportSupportBarProps
export const VantageTitle = ExportVantageTitle
export type User = ExportUser
export type NotificationLabel = Label
